module.exports = __webpack_public_path__ + "static/img/custom-chat.c2dfbbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/generate/custom-chat.png
// module id = RBz8
// module chunks = 1